import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const SellProperties = ({ title }) => {
  const propertyInfo = (
    <>
      <p>
        The <strong>Property Dealers Market</strong> is a specialized platform designed for <strong>property dealers, real estate companies, and real estate schemes</strong>. It's for <strong>Business-to-Business (B2B)</strong> connectivity and <strong>Business-to-Consumer (B2C)</strong> connectivity.
      </p>
      <p>
        Through this platform, users can search for required properties, including <strong>land, plots, houses, shops, flats, and commercial spaces</strong>. Property dealers and companies can showcase their listings, while users can easily explore and compare available real estate options.
      </p>
      <p>
        The <strong>Property Dealers Market</strong> simplifies property discovery by connecting buyers directly with verified dealers and real estate providers in one trusted marketplace.
      </p>
           <a href="https://www.youtube.com" target="_blank">
  <strong>Click here to see how to Explore the Properties</strong>
</a>
    </>
  );

  return (
    <div>
      <Row>
        <Col lg="12" className="mt-sm-3 mt-md-0">
          {/* CardNav displays title + full info */}
          <CardNav Header={title} myid={1} myinfo={propertyInfo} />

          {/* BoxData for Sell Properties */}
          <Card className="shadow-main mt-2">
            <BoxData
              Title="Properties For Sale"
              Butonn="Search Now"
              imgg={images.SellProperties}
              link="/find-property"
              buy="fifteen"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SellProperties;
